import { useContext } from "react";
import { FeatureContext } from '../../../Context';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from '@chakra-ui/react';
import { formatDate, getDescendantProp, lang } from "../../../Utils";
import { DateTime } from "luxon";

const Text = ({ label, data, field }) => {
  const value = getDescendantProp(data, field);
  return (!!value) ? <div className="bf-enquiry-data-item">
    <label>{lang(label)}</label>
    <span>{lang(value)}</span>
  </div> : null;
}

const Date = ({ label, data, field }) => {
  const value = getDescendantProp(data, field);
  return (!!value) ? <div className="bf-enquiry-data-item">
    <label>{lang(label)}</label>
    <span>{formatDate(value)}</span>
  </div> : null;
}

const Details = () => {
  const context = useContext(FeatureContext);

  return <Tabs className="bf-enquiry-tabs">
    <TabList className="bf-enquiry-tabs-list">
      <Tab className="bf-enquiry-button">{lang('Details')}</Tab>
      <Tab className="bf-enquiry-button">{lang('Product Information')}</Tab>
    </TabList>
    <TabPanels className="bf-enquiry-panels">
      <TabPanel className="bf-enquiry-panel bf-enquiry-data">
        <Text field="enquiryId" data={context?.details} label="Enquiry Number" />
        <Text field="status" data={context?.details} label="Status" />
        <Text field="filter1" data={context?.details} label="Topic" />
        <Text field="filter2" data={context?.details} label="Field" />
        <Text field="filter3" data={context?.details} label="Assets" />
        <Date field="createdDate" data={context?.details} label="Created Date" />
        <Text field="notes" data={context?.details} label="Notes" />
      </TabPanel>
      <TabPanel className="bf-enquiry-panel bf-enquiry-data">
        <Text field="materialNumber" data={context?.details} label="Material Number" />
        <Text field="serialNumber" data={context?.details} label="Serial Number" />
        <Text field="typeOfProduct" data={context?.details} label="Type of Product" />
        <Text field="sector" data={context?.details} label="Sector" />
        <Text field="subsector" data={context?.details} label="Sub-sector" />
        <Date field="expectedDeliveryDate" data={context?.details} label="Expected Delivery" />
        <Text field="designation" data={context?.details} label="Designation" />
        <Text field="numberOfGearboxes" data={context?.details} label="Gearbox Number" />
      </TabPanel>
    </TabPanels>
  </Tabs>
}

export default Details;